import { logger } from 'Services/logger/logger';
import { getTransport, getTransportOptions } from 'Utilities/transport.helpers';

// TODO: Refactor to TS
const resolveTransportOptions = async ({ enquiryId, transport, user }) => {
	if (transport?.transportOptions) {
		return transport?.transportOptions;
	}

	const response = await getTransportOptions(transport, { allowAllDealers: true, enquiryId }, user);
	return response?.transportOptions || {};
};

export const getTransportAndTransportOptions = async ({ id, isPostSaleAction, user }) => {
	try {
		const transport = isPostSaleAction ? await getTransport({ enquiryId: id }, user) : {};
		const transportOptions = await resolveTransportOptions({ enquiryId: id, transport, user });

		return {
			transport,
			transportOptions,
		};
	} catch (error) {
		logger.error({
			error,
			message: error?.message || 'Error getting transport',
			scope: 'getTransportAndTransportOptions',
		});
		return undefined;
	}
};
